// Match and remove newlines and tabs that should not be in html
export function removeNewlinesAndTabs(html: string): string {
    // This regular expression matches '\n' or '\t'
    return html.replace(/[\n\t]/g, "")
}
